export const config = {
    server: "192.227.100.9",
    serverPort: "5777",
    peticion: "http://",
  };
  
export const DiasParaDesdeListados = 0;
export const DiasParaHastaListados = 0;